import React from "react";
import { Card, Button } from "react-bootstrap";
import bg from "../../../assets/img/bg/payroll-bg.png";

export default function PayrollForecast() {
  return (
    <>
      <Card className="h-100"
        style={{
          position: "relative",
          borderRadius: "5px",
          overflow: "hidden",
          height: "100%",
          minHeight: "260px",
          background: "#000",
          border:"2px solid #e6e6e6",
        }}
      >
        {/* Background Image */}
        <img
          src={bg}
          alt="bg"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            top: 0,
            left: 0,
            zIndex: 0,
          }}
        />

        {/* Overlay Content */}
        <Card.Body
          style={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            padding: "20px",
            color: "#fff",
          }}
        >
          {/* TEXT */}
          <div>
            <h5
              style={{
                fontWeight: "700",
                textDecoration: "underline",
                marginBottom: "12px",
                fontSize: "18px",
              }}
            >
              Payroll Forecast
            </h5>

            <p
              style={{
                fontSize: "14px",
                lineHeight: "1.6",
                marginBottom: "20px",
                color: "#dcdcdc",
                maxWidth: "95%",
              }}
            >
              Upgrade to Payroll Forecasting to predict upcoming salary
              expenses, optimize cash flow, and make confident financial
              decisions.
            </p>
          </div>

          {/* BUTTON */}
          <Button
            style={{
              background: "#f2540b",
              border: "none",
              borderRadius: "8px",
              padding: "12px",
              fontWeight: "600",
              fontSize: "15px",
              width: "100%",
            }}
          >
            Upgrade Now
          </Button>
        </Card.Body>
      </Card>

      {/* Responsive Fix */}
      <style>
        {`
          @media (max-width: 768px) {
            .card-body {
              padding: 16px !important;
            }
          }
        `}
      </style>
    </>
  );
}
